import { render } from "./OfferCallUl.vue?vue&type=template&id=70861c7a"
import script from "./OfferCallUl.vue?vue&type=script&lang=js"
export * from "./OfferCallUl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__